import { Drawer } from 'antd';
import { MobileDrawer } from '@Components/index';
import { ViewResolver } from '@Components/ViewResolver';
import { PurchaseItemResponse } from '@Types/api/form';
import { OverviewMaterialsContent } from './components/OverviewContent';

interface OverviewMaterialsProps {
  overviewItems: PurchaseItemResponse[];
  selectedOverviewItems: PurchaseItemResponse[];
  isOpen: boolean;
  onClose: () => void;
  handleAddMaterial: (purchaseItem: PurchaseItemResponse) => void;
  handleRemoveMaterial: (purchaseItem: PurchaseItemResponse) => void;
  handleRemoveAllMaterial: () => void;
  handleSelectOverviewItem: (purchaseItem: PurchaseItemResponse) => void;
  handleUnselectOverviewItem: (purchaseItem: PurchaseItemResponse) => void;
  handleUnselectAllOverviewItems: () => void;
  handleSelectAllOverviewItems: () => void;
}

const OverviewMaterials: React.FC<OverviewMaterialsProps> = ({
  isOpen,
  onClose,
  overviewItems,
  selectedOverviewItems,
  handleAddMaterial,
  handleRemoveMaterial,
  handleRemoveAllMaterial,
  handleSelectOverviewItem,
  handleUnselectOverviewItem,
  handleSelectAllOverviewItems,
  handleUnselectAllOverviewItems,
}) => {
  return (
    <ViewResolver
      desktop={
        <Drawer
          width={410}
          title={`Overview (${overviewItems.length})`}
          onClose={onClose}
          open={isOpen}
        >
          <OverviewMaterialsContent
            selectedOverviewItems={selectedOverviewItems}
            overviewItems={overviewItems}
            handleAddMaterial={handleAddMaterial}
            handleRemoveMaterial={handleRemoveMaterial}
            handleRemoveAllMaterial={handleRemoveAllMaterial}
            handleSelectOverviewItem={handleSelectOverviewItem}
            handleUnselectAllOverviewItems={handleUnselectAllOverviewItems}
            handleUnselectOverviewItem={handleUnselectOverviewItem}
            handleSelectAllOverviewItems={handleSelectAllOverviewItems}
          />
        </Drawer>
      }
      mobile={
        <MobileDrawer
          title={`Overview (${overviewItems.length})`}
          onClose={onClose}
          open={isOpen}
        >
          <OverviewMaterialsContent
            selectedOverviewItems={selectedOverviewItems}
            overviewItems={overviewItems}
            handleAddMaterial={handleAddMaterial}
            handleRemoveMaterial={handleRemoveMaterial}
            handleRemoveAllMaterial={handleRemoveAllMaterial}
            handleSelectOverviewItem={handleSelectOverviewItem}
            handleUnselectOverviewItem={handleUnselectOverviewItem}
            handleUnselectAllOverviewItems={handleUnselectAllOverviewItems}
            handleSelectAllOverviewItems={handleSelectAllOverviewItems}
          />
        </MobileDrawer>
      }
    />
  );
};

export default OverviewMaterials;
